import { useKeycloak } from '@react-keycloak/web';
import { KeycloakLoginOptions } from 'keycloak-js';
import { useCallback, useEffect, useState } from 'react';
import { getLoginRedirectUri } from 'core/util/StorageRedirectRulesHelper';

const useLogged = () => {
    const { keycloak } = useKeycloak();
    const [auth, setAuth] = useState<boolean>(false);

    useEffect(() => {
        setAuth(keycloak.authenticated ?? false);
    }, []);

    const login = async (redirectPath: string, params?: string) => {
        const redirectUrl = new URL(redirectPath, window.location.origin);
        if (params) {
            new URLSearchParams(params).forEach((value, key) => redirectUrl.searchParams.append(key, value));
        }

        const options: KeycloakLoginOptions = {
            redirectUri: getLoginRedirectUri(`${redirectUrl.pathname}${redirectUrl.search}${redirectUrl.hash}`),
        };

        await keycloak?.login(options);
    };

    const register = async (redirectPath?: string) => {
        const options: KeycloakLoginOptions = {
            redirectUri: getLoginRedirectUri(redirectPath),
        };

        await keycloak?.register(options);
    };

    return { authenticated: auth, login, register };
};

export default useLogged;
